module.exports = __webpack_public_path__ + "img/canvas-day-warm.9f1400c3.jpg";